import "./GeschaeftsregelWrapper.scss";

export default function GeschaeftsregelWrapper({
	children,
}: {
	children: React.ReactNode;
}): JSX.Element {
	return <div className="geschaeftsregel-wrapper">{children}</div>;
}
